/** Pills de formato — mesmo estilo da home (`ObrasHome`). */
export function formatoPillClassName(ativo: boolean): string {
    const base =
        'cursor-pointer shrink-0 rounded-full border px-3 py-1.5 text-xs font-medium whitespace-nowrap md:text-sm ' +
        'transition-[color,background-color,border-color,box-shadow,transform,filter] duration-200 ease-out ';
    if (ativo) {
        return (
            base +
            'ring-1 ring-inset hover:brightness-110 active:scale-[0.98] motion-reduce:hover:brightness-100 motion-reduce:active:scale-100'
        );
    }
    return (
        base +
        'border-white/10 bg-white/5 text-white/80 ' +
        'hover:border-white/28 hover:bg-white/[0.13] hover:text-white ' +
        'hover:shadow-[0_4px_18px_rgba(0,0,0,0.35),0_0_20px_rgba(255,255,255,0.07)] hover:-translate-y-px ' +
        'active:scale-[0.98] motion-reduce:hover:translate-y-0 motion-reduce:hover:shadow-none motion-reduce:active:scale-100'
    );
}
